var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1200,
    width: 1600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#eff6ff",
    width: 1600,
    height: 1200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M417.53 290.92L1182.47 294.15C1208.31 294.15 1215.4 296.86 1215.4 322.7L1229.25 360.31V925.11C1229.25 950.95 1208.31 971.89 1182.47 971.89H417.53C391.69 971.89 370.75 950.95 370.75 925.11V360.31L383.35 322.7C383.35 296.86 391.69 290.92 417.53 290.92Z",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.53 275.92H1182.47C1208.31 275.92 1229.25 296.86 1229.25 322.7V360.31H370.75V322.7C370.75 296.86 391.69 275.92 417.53 275.92Z",
    fill: "#d5d5d5",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.7 333.74C444.75 333.74 451.28 327.21 451.28 319.16 451.28 311.1 444.75 304.57 436.7 304.57 428.64 304.57 422.11 311.1 422.11 319.16 422.11 327.21 428.64 333.74 436.7 333.74Z",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.1 333.74C492.16 333.74 498.69 327.21 498.69 319.16 498.69 311.1 492.16 304.57 484.1 304.57 476.05 304.57 469.52 311.1 469.52 319.16 469.52 327.21 476.05 333.74 484.1 333.74Z",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.51 333.74C539.56 333.74 546.1 327.21 546.1 319.16 546.1 311.1 539.56 304.57 531.51 304.57 523.46 304.57 516.92 311.1 516.92 319.16 516.92 327.21 523.46 333.74 531.51 333.74Z",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.27 318.84H907.83",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M799.92 847.28C891.39 847.28 965.55 773.12 965.55 681.64 965.55 590.17 891.39 516 799.92 516 708.44 516 634.28 590.17 634.28 681.64 634.28 773.12 708.44 847.28 799.92 847.28Z",
    fill: "#1f2223",
    opacity: 0.2,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.69 741.91H862.07",
    stroke: "#23211f",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.92 809.7C891.39 809.7 965.55 735.54 965.55 644.06 965.55 552.59 891.39 478.43 799.92 478.43 708.44 478.43 634.28 552.59 634.28 644.06 634.28 735.54 708.44 809.7 799.92 809.7Z",
    fill: "#3d84a8",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.65 743.5V727.75L770.43 727.6V744.95H739.36C715.8 744.95 696.86 758.82 688.33 766.34 755.83 828.05 860.48 823.29 922.19 755.79 923.06 754.78 924.07 753.76 924.94 752.75 915.98 746.83 905.43 743.65 894.59 743.36L863.65 743.5Z",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.44 652.3C725.77 635.53 725.62 614.87 728.51 596.22 730.54 583.5 733.86 571.79 740.8 563.12 757.86 541.88 803.67 533.64 840.38 560.52 877.1 587.4 875.22 625.27 873.77 642.33L863.51 699.71 863.65 728.18H770.43L770.29 712.72C770.29 712.72 749.91 717.05 737.91 708.81 721.72 697.68 716.81 680.48 722.44 652.3Z",
    fill: "#ac704e",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.8 563.12C757.86 541.88 806.42 528.58 843.13 555.46 879.84 582.35 875.22 625.27 873.77 642.33L863.51 699.71C863.51 699.71 835.9 691.04 824.2 669.07 824.2 669.07 864.23 651.14 846.02 625.42 828.53 600.7 798.04 631.2 798.04 631.2 780.55 625.42 763.06 600.56 763.06 600.56 736.9 602 728.51 596.08 728.51 596.08 730.54 583.5 733.86 571.79 740.8 563.12Z",
    fill: "#221f1f",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.39 643.48C769.87 643.48 771.88 641.47 771.88 639 771.88 636.53 769.87 634.52 767.39 634.52 764.92 634.52 762.91 636.53 762.91 639 762.91 641.47 764.92 643.48 767.39 643.48Z",
    fill: "#000000",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.45 640.45C737.92 640.45 739.93 638.44 739.93 635.97 739.93 633.5 737.92 631.49 735.45 631.49 732.97 631.49 730.97 633.5 730.97 635.97 730.97 638.44 732.97 640.45 735.45 640.45Z",
    fill: "#000000",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.14 650.86C744.41 653.31 743.98 655.48 744.41 656.35 745.14 657.65 746.29 658.8 747.59 659.53",
    stroke: "#23211f",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.02 672.1C757.28 674.7 753.37 675.86 749.62 674.99",
    stroke: "#23211f",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.06 709.1C782.86 711.42 775.78 710.98 770.29 712.72",
    stroke: "#23211f",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.2 641.46L814.08 648.69",
    stroke: "#23211f",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1134.06 644.71L1127.32 660.72 1121.63 677.99C1121.63 678.2 1121.63 678.41 1122.05 678.41L1141.01 679.04 1158.91 673.57C1159.12 673.57 1159.12 673.36 1159.12 673.36L1149.22 657.77 1138.9 644.08C1137.43 642.4 1134.69 642.82 1134.06 644.71Z",
    fill: "#3d84a8",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.41 608.89L1214.3 622.16 1204.61 637.11V637.32L1222.73 643.01 1241.47 642.38C1241.68 642.38 1241.89 642.16 1241.68 641.95L1236.2 624.89 1229.89 609.31C1229.25 607.2 1225.89 606.78 1224.41 608.89Z",
    fill: "#3d84a8",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.13 820.78L1204.61 637.34C1204.61 637.13 1204.82 637.13 1204.82 637.13L1241.89 642.4C1242.1 642.4 1242.1 642.61 1242.1 642.61L1216.62 826.05 1179.13 820.78Z",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.2 601.12L1214.51 622.18 1236.63 625.13 1228.62 601.12C1228.41 600.91 1228.2 600.91 1228.2 601.12Z",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.63 678.2L1158.91 673.36C1159.12 673.36 1159.12 673.36 1159.12 673.57L1182.92 857.22 1145.22 862.06 1121.42 678.41C1121.42 678.2 1121.63 678.2 1121.63 678.2Z",
    fill: "#3d84a8",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.11 636.71L1127.11 660.72 1149.01 657.77 1135.53 636.71C1135.53 636.5 1135.32 636.5 1135.11 636.71Z",
    fill: "#3d84a8",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.78 965.69H1121.63C1121.63 965.69 1121.42 965.69 1121.42 965.47L1096.36 845.85 1086.46 770.24C1086.46 770.03 1086.46 770.03 1086.67 770.03H1267.38C1267.59 770.03 1267.59 770.24 1267.59 770.24L1257.69 845.85 1231.78 965.69C1231.99 965.69 1231.99 965.47 1231.78 965.69Z",
    fill: "#2e2c5b",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.36 845.85L1113 972.21H1241.26L1257.69 845.85H1096.36Z",
    fill: "#3d84a8",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M369.34 387.85C419.82 358.57 484.5 375.75 513.78 426.23 543.06 476.71 525.88 541.38 475.4 570.67 424.92 599.95 360.25 582.76 330.96 532.29 301.68 481.81 318.87 417.14 369.34 387.85Z",
    fill: "#3d84a8",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.23 463.12C479.13 467.09 477.26 471.12 473.8 473.13 473.69 473.19 473.75 473.3 473.75 473.3 476 474.52 477.6 476.54 478.19 479 479.08 482.97 477.21 487 473.75 489.01 473.65 489.07 473.71 489.17 473.71 489.17 476.47 490.8 478.39 493.61 478.42 496.82 478.42 501.17 475.39 504.89 471.21 505.91L447.28 511.8C438.82 513.9 430.02 514.94 421.32 514.93 417.95 514.92 415.09 512.66 414.25 509.5L402.47 461.63C402.03 459.92 402.29 457.95 403.23 456.42 407.74 448.47 421.44 423.98 423.93 421.27 437.17 411.2 435.01 442.05 434.93 448.69 434.99 448.79 434.99 448.79 435.1 448.73 437.29 448.16 463.11 441.88 463.11 441.88 471.76 439.39 478.84 450.15 472.23 456.65 472.13 456.71 472.19 456.81 472.35 456.86 475.23 457.71 477.61 460.12 478.23 463.12Z",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.65 459.73L407.96 517.77C408.63 520.61 406.9 523.44 404.12 524.21L383.89 529.22C381.05 529.88 378.22 528.16 377.45 525.38L363.08 467.23C362.41 464.39 364.14 461.57 366.92 460.79L387.32 455.83C390.16 455.17 393.26 456.88 393.65 459.73Z",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M382.73 987.13L317.91 1035.55 342.52 959.58 266.65 950.06 335.73 912.58 298.86 838.43 374.43 879.25 403.7 817.26 423.76 889.59 500.94 861.73 444.82 928.99 512.69 975.08 431.25 975.38 432.37 1053.78 382.73 987.13Z",
    stroke: "#1f2223",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1076.99 408.76C1110.24 298.39 1173.15 266.76 1207.17 268.37 1252.17 270.53 1278.49 343.3 1249.66 391.09 1220.82 438.87 1180.51 384.37 1210.81 303.44 1238.17 230.22 1304.77 193.76 1349.54 220.09 1378.07 236.95 1403.56 277.54 1391.49 320.07 1380.74 358.06 1341.4 333.19 1367.07 295.75 1397.83 250.71 1458.11 261.7 1477.13 266.39",
    stroke: "#1f2223",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.52 759.63L235.01 777.68 258.98 833.1 330.52 759.63Z",
    fill: "#000000",
    opacity: 0.2,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52 759.63L214.21 769.91 238.17 825.32 330.52 759.63Z",
    fill: "#2e2c5b",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1224.04 500.95L1352 455.39 1362.16 539.14 1224.04 500.95Z",
    fill: "#000000",
    opacity: 0.2,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.04 500.95L1371.62 431.34 1381.78 515.09 1224.04 500.95Z",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M601.76 234.6L582.34 181.61C582.34 181.61 582.31 181.6 582.29 181.59L552.81 200.58C552.8 200.61 552.8 200.61 552.81 200.65L601.68 234.63C601.73 234.65 601.76 234.6 601.76 234.6Z",
    fill: "#464646",
    opacity: 0.2,
    strokeWidth: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.77 234.57L584.82 168.92C584.84 168.9 584.8 168.91 584.77 168.9L555.3 187.89C555.28 187.92 555.28 187.92 555.31 187.93L601.71 234.57C601.72 234.61 601.76 234.6 601.77 234.57Z",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 4,
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6517c53bb33eb9fe61b770c6372b337f.svg";
export { ForwardRef as ReactComponent };